// extracted by mini-css-extract-plugin
export default {"container":"wl-z","disabled":"xl-z","subtotal":"yl-z","legal":"zl-z"};